import { call, put, takeLatest } from 'redux-saga/effects';
import api from '../../../api-new/http';
import { cancelRegistrationFailure, CancelRegistrationRequestAction, cancelRegistrationSuccess, fetchParticipantFailure, FetchParticipantFailureAction, FetchParticipantRequestAction, fetchParticipantsFailure, fetchParticipantsRequest, FetchParticipantsRequestAction, fetchParticipantsSuccess, fetchParticipantSuccess, registerContestFailure, RegisterContestRequestAction, registerContestSuccess } from './actions';
import { CANCEL_REGISTRATION_REQUEST, FETCH_PARTICIPANT_BY_ID_REQUEST, FETCH_PARTICIPANTS_BY_ID_REQUEST, REGISTER_CONTEST_REQUEST } from './constants';
import { sendError } from '../../public/errorHandler';
import { getErrorSetup } from '../../../helpers/getErrorSetup';
import { message, notification } from 'antd';
import { appUrls } from '../../../api-new/urls';
export function* RegisterContestSaga(action: RegisterContestRequestAction) {
    try {
        const contest = action.payload;

        const token = localStorage.getItem('csrfToken');
        if (!token) {
            throw new Error('Token not found');
        }
        const response = yield call(() =>
            api.post(`${appUrls.tradeURL}/contests/${contest.contestId}/register`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }),
        );
        yield put(fetchParticipantsRequest(contest.contestId!));
        yield put(registerContestSuccess(response.data.data));
        message.success('Register success');
    } catch (error) {
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
        yield put(registerContestFailure(error as any));
     
    }
}
export function* CancelRegistrationSaga(action: CancelRegistrationRequestAction) {
    try {
        const contest = action.payload;

        const token = localStorage.getItem('csrfToken');
        if (!token) {
            throw new Error('Token not found');
        }
        const response = yield call(() =>
            api.post(`${appUrls.tradeURL}/contests/${contest.contestId}/cancel`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }),
        );

        yield put(cancelRegistrationSuccess(response.data.data));
        yield put(fetchParticipantsRequest(contest.contestId!));
        message.success('Cancel registration success');
    } catch (error) {
        yield put(cancelRegistrationFailure(error as any));
        yield put(
            sendError({
                error: getErrorSetup(error),
                processingType: 'alert',
            }),
        );
    }
}
export function* FetchMyParticipantSaga(action: FetchParticipantRequestAction) {
    try {
        const contestId = action.payload;
        const token = localStorage.getItem('csrfToken');
        if (!token) {
            throw new Error('Token not found');
        }
        const response = yield call(() =>
            api.get(`${appUrls.tradeURL}/contests/${contestId}/my-participant/show`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }),
        );

        yield put(fetchParticipantSuccess(response.data.data));
    } catch (error) {
        yield put(fetchParticipantFailure(error as any));
        //    yield put(
        //        sendError({
        //            error: getErrorSetup(error),
        //            processingType: 'alert',
        //        }),
        //    );
    }
}
export function* FetchParticipantsByIdSaga(action: FetchParticipantsRequestAction) {
    try {
        const contestId = action.payload;
        const token = localStorage.getItem('csrfToken');
        if (!token) {
            throw new Error('Token not found');
        }
        const response = yield call(() =>
            api.get(`${appUrls.tradeURL}/contests/${contestId}/paticipants/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json',
                },
            }),
        );

        yield put(fetchParticipantsSuccess(response.data.data));
    } catch (error) {
        yield put(fetchParticipantsFailure(error as any));
        //    yield put(
        //        sendError({
        //            error: getErrorSetup(error),
        //            processingType: 'alert',
        //        }),
        //    );
    }
}
export function* rootContestParticipantSaga(): Generator {
    yield takeLatest(REGISTER_CONTEST_REQUEST, RegisterContestSaga);
    yield takeLatest(FETCH_PARTICIPANT_BY_ID_REQUEST, FetchMyParticipantSaga);
    yield takeLatest(FETCH_PARTICIPANTS_BY_ID_REQUEST, FetchParticipantsByIdSaga);
    yield takeLatest(CANCEL_REGISTRATION_REQUEST, CancelRegistrationSaga);
}
